import React from 'react';
import styles from '../css/DetailForm.module.css';
import { Form } from 'antd';
import { FormProps, FormItemProps } from 'antd/lib/form';

const DetailForm = (props: FormProps) => {

    let addOnClass: string = "";
    if (typeof props.className !== "undefined") {
        addOnClass = props.className
    }

    return (
        <Form {...props} className={styles.detailForm + " " + addOnClass}
        />
    )
}

DetailForm.Item = (props: FormItemProps) => { return <Form.Item {...props}></Form.Item> }

export default DetailForm;